import { api } from "./apiConfig";

export const saveAppointment = async ({ data, shouldNotifyClient = false }) => {
  const { data: responseData } = await api.post("/appointments", { data, shouldNotifyClient });
  return responseData;
};

export const getAppointmentsByClientId = async ({
  page = 1,
  limit = 10,
  clientId,
}) => {
  const { data } = await api.get(`/appointments/client/${clientId}`, {
    params: { page, limit },
  });
  return data;
};

export const getAppointmentsByDateRange = async ({
  start,
  end,
  page = 1,
  limit = 5,
}) => {
  const { data } = await api.get("/appointments/daterange", {
    params: { start, end, page, limit },
  });
  return data;
};

export const getCalendarSummary = async ({ start, end, timezone }) => {
  const { data } = await api.get("/appointments/calendar-summary", {
    params: { start, end, timezone },
  });
  return data;
};

export const getUnresolvedPastAppointments = async () => {
  const { data } = await api.get("/appointments/unresolved");
  return data;
};

export const patchAppointment = async ({
  id,
  data,
  shouldNotifyClient = false,
}) => {
  await api.patch(`/appointments/${id}`, { id, shouldNotifyClient, ...data });
};
